import { Modal } from '@mui/base';
import { Backdrop, Dialog } from '@mui/material';
import Player, { PlayerProps } from "./player";
interface VideoPlayerProps extends PlayerProps {
}

const VideoPlayer = (props: VideoPlayerProps) => {
  return props.isEmbed ? (
    props.open &&
    <div className="embedWrapper">
      <div className="customContainer" style={{borderRadius: "4px"}}>
        <Player {...props} />
      </div>
    </div>
  ) : (
    <Dialog
    open={props.open}
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
    className="videoModal"
    slots={{ backdrop: Backdrop }}
    slotProps={{
      backdrop: {
        style: {
          zIndex: 999,
        }
      }
    }}
  >
    <Player {...props} />
  </Dialog>
  )
}

export default VideoPlayer;